angular.module('unergie.main')
.factory('TableGeneratorService', ($sce, $location, $filter, $templateCache, MetaWatcher, $q, $timeout, debouncer, DataAccessSearch, NgTableParams, ErrorCatcher) => {
    const DEFAULT_DEBOUNCE = 500

    const labels = {
        select: 'Choisir',
        itemsSelected: 'sél.',
        selectAll: 'Tout',
        unselectAll: 'Aucun',
    }

    const template = `<input type="text" ng-class="{ filled: params.filter()[name] }" name="{{name}}" ng-disabled="$filterRow.disabled" ` +
        `ng-model="params.filter()[name]" class="input-filter form-control {{params.columns[name]}}" ` +
        `uib-tooltip-html="params.titles[name]" tooltip-append-to-body="true" tooltip-class="sm" tooltip-placement="auto top-right" placeholder="{{params.placeholders[name]}}" ` +
        `ng-model-options="{debounce: { default: (params.debounce && params.debounce[name]), submit: 0 } || 850, updateOn: 'default submit'}" submit-listener/> `
    $templateCache.put('ng-table/filters/text.html', template)

    const templateSelect = `<select ng-options="data.id as data.title for data in $selectData" ng-table-select-filter-ds="$column" ` +
        `ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" name="{{name}}" ` +
        `class="filter filter-select form-control {{params.columns[name]}}" ng-class="{ filled: params.filter()[name] }"> ` +
        `<option style="display:none" value=""></option> ` +
        `</select> `
    $templateCache.put('ng-table/filters/select.html', templateSelect)

    const templateMulti = `<multiselect options="$selectData" ng-table-select-filter-ds="$column" id-prop="id" display-prop="title" ` +
        `ng-disabled="$filterRow.disabled" ng-model="params.filter()[params.bindings[name] || name]" name="{{params.bindings[name] || name}}" ` +
        `class="filter filter-select form-control {{params.columns[name]}}" ng-class="{ filled: params.filter()[params.bindings[name] || name] }" ` +
        `show-select-all="true" show-unselect-all="true" labels="params.labels">` +
        `</multiselect> `
    $templateCache.put('ng-table/filters/multi.html', templateMulti)

    const placeholdersRef = {
        search_wildcard: '',
        search_strict: '',
        search_operator: '',
        search_date: '',
        strict_wildcard: '⏎',
    }

    const titleRef = {
        search_wildcard: 'Recherche par chaîne de caractères :<br>' +
        '"on*r" : trouvera "Bonjour"<br>' +
        '"!on" : exclut les valeurs contenant "on"<br>' +
        '"!on,an" : exclut les valeurs contenant "on" ou "an"<br>' +
        '"on,an" : trouvera les valeurs contenant "on" ou "an"<br>' +
        '"&lt;null&gt;" : pour trouver les valeurs nulles<br>' +
        '"!&lt;null&gt;" : pour trouver les valeurs non-nulles',
        search_strict: 'Recherche stricte (sensible à la casse)',
        search_operator: 'Recherche numérique avec opérateurs :<br>' +
        '"&lt;9" : inférieur à 9<br>' +
        '"&lt;=9" : inférieur ou égal à 9<br>' +
        '"!9" : sauf 9<br>' +
        '"!1,2,3" : sauf les valeurs 1, 2 et 3<br>' +
        '"1,2,3" : que les valeurs 1, 2 et 3',
        search_date: 'Recherche de date avec opérateurs :<br>' +
        '"&lt;12/09/2017" : avant le 12 sept minuit<br>' +
        '"&lt;12/09/2017 11:10" : avant le 12 sept, 11h10<br>' +
        '"&gt;12/09/2017" : après le 12 sept minuit<br>' +
        '"12/09/2017&lt;&lt;25/09/2017" : entre le 12 et le 25 sept',
        filter_only: 'Filtre sur la page actuelle seulement !',
        strict_wildcard: 'Recherche stricte par chaîne de caractères :<br>' +
        '"on*r" : trouvera "onjour"<br>' +
        '"!on" : exclut les valeurs "on"<br>' +
        '"!on,an" : exclut les valeurs "on" et "an"<br>' +
        '"on,an" : trouvera les valeurs "on" ou "an"<br>' +
        '"&lt;null&gt;" : pour trouver les valeurs nulles<br>' +
        '"!&lt;null&gt;" : pour trouver les valeurs non-nulles<br><br>' +
        '<span class="fa fa-warning"></span> : il faut appuyer sur "Entrée" pour valider la saisie',
    }

    const computeOperator = function (key, value, toReturn) {
        if (value.indexOf('<=') === 0) {
            if (value.length > 2) {
                toReturn.lte.push(`${key}=${value.substring(2)}`)
            }
        } else if (value.indexOf('<') === 0) {
            if (value.length > 1) {
                toReturn.lt.push(`${key}=${value.substring(1)}`)
            }
        } else if (value.indexOf('>=') === 0) {
            if (value.length > 2) {
                toReturn.gte.push(`${key}=${value.substring(2)}`)
            }
        } else if (value.indexOf('>') === 0) {
            if (value.length > 1) {
                toReturn.gt.push(`${key}=${value.substring(1)}`)
            }
        } else if (value.indexOf('!') === 0) {
            if (value.length > 1) {
                if (value.indexOf(',') > -1) {
                    toReturn.notin.push(`${key}=${value.substring(1)}`)
                } else {
                    toReturn.neq.push(`${key}=${value.substring(1)}`)
                }
            }
        } else if (value.indexOf(',') > -1) {
            if (value.length > 1) {
                toReturn.in.push(`${key}=${value}`)
            }
        } else {
            toReturn.search[key] = value
        }
    }

    const computeDateOperator = function (key, value, toReturn, strictDate) {
        const format = (v) => (strictDate ? moment(v, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD') : moment(v, 'DD/MM/YYYY HH:mm').toISOString())
        if (value === '<null>') {
            toReturn.null.push(key)
        } else if (value === '!<null>') {
            toReturn.notnull.push(key)
        } else if (value.indexOf('<') === 0) {
            if (value.length > 1) {
                toReturn.lt.push(`${key}=${format(value.substring(1))}`)
            }
        } else if (value.indexOf('>') === 0) {
            if (value.length > 1) {
                toReturn.gt.push(`${key}=${format(value.substring(1))}`)
            }
        } else if (value.indexOf('<<') > 0) {
            const dates = value.split('<<')
            toReturn.gt.push(`${key}=${format(dates[0])}`)
            toReturn.lt.push(`${key}=${format(dates[1])}`)
        } else {
            toReturn.search[key] = format(value)
        }
    }

    const computeSearchAndOrder = function (params, handler, override, csvMode) {
        const { columns } = handler
        const toReturn = {
            search: {},
            filterObj: {},
            gt: [],
            gte: [],
            lt: [],
            lte: [],
            neq: [],
            notin: [],
            in: [],
            like: [],
            unlike: [],
            null: [],
            notnull: [],
            exists: [],
            notexists: [],
            columns: [],
        }
        if (handler.show) {
            toReturn.columns = _.compact(_.map(handler.show, (value, key) => {
                if (columns[key] && columns[key].mode &&
                    (value || (columns[key].mode === 'hidden' && (!csvMode || columns[key].translateCsv)) || columns[key].mandatory) && (columns[key].mode !== 'filter_only') &&
                    (!csvMode || !columns[key].csvIgnore)) {
                    if (csvMode && columns[key].translateCsv) {
                        return `${key}=${columns[key].translateCsv}`
                    }
                    if (!csvMode && columns[key].translate) {
                        return `${key}=${columns[key].translate}`
                    }
                    return key
                }
            }))
        }
        _.assign(toReturn, _.cloneDeep(override))
        const filterObj = params.filter()
        const searchObj = {}

        _.forEach(filterObj, (value, key) => {
            if (value || (value === 0) || (value === false)) {
                const fieldConf = columns[key] || _.find(columns, { translate: key })
                if (fieldConf) {
                    const mode = fieldConf.hidden_search || fieldConf.mode
                    if (mode !== 'hidden') {
                        searchObj[key] = value
                    }
                    let valueNormalized = value
                    if (_.isBoolean(value)) {
                        valueNormalized = `${value}`
                    }
                    if (_.isArray(value)) {
                        valueNormalized = value.join(',')
                    }
                    if (fieldConf.transform) {
                        valueNormalized = fieldConf.transform(valueNormalized)
                    }

                    _.forEach(valueNormalized.split('&&'), (val) => {
                        const v = val.trim()
                        if (v || (v === 0) || (v === false)) {
                            switch (mode) {
                                case 'search_wildcard':
                                    if (v === '<null>') {
                                        toReturn.null.push(key)
                                    } else if (v === '!<null>') {
                                        toReturn.notnull.push(key)
                                    } else if (v.length === fieldConf.length) {
                                        toReturn.search[key] = v
                                    } else if (v.indexOf('!') === 0) {
                                        toReturn.unlike.push(`${key}=${_.compact(v.substring(1).split(',')).join(',')}`)
                                    } else {
                                        toReturn.like.push(`${key}=${_.compact(v.split(',')).join(',')}`)
                                    }
                                    break
                                case 'strict_wildcard':
                                    if (v === '<null>') {
                                        toReturn.null.push(key)
                                    } else if (v === '!<null>') {
                                        toReturn.notnull.push(key)
                                    } else if (v.includes('%') || v.includes('*')) {
                                        if (v.indexOf('!') === 0) {
                                            toReturn.unlike.push(`${key}=${_.compact(v.substring(1).split(',')).join(',')}`)
                                        } else {
                                            toReturn.like.push(`${key}=${_.compact(v.split(',')).join(',')}`)
                                        }
                                    } else if (v.indexOf('!') === 0) {
                                        toReturn.notin.push(`${key}=${_.compact(v.substring(1).split(',')).join(',')}`)
                                    } else {
                                        toReturn.in.push(`${key}=${_.compact(v.split(',')).join(',')}`)
                                    }
                                    break
                                case 'search_strict':
                                    if (v === '<null>') {
                                        toReturn.null.push(key)
                                    } else if (v === '!<null>') {
                                        toReturn.notnull.push(key)
                                    } else if (v.indexOf('!') === 0) {
                                        toReturn.notin.push(`${key}=${_.compact(v.substring(1).split(',')).join(',')}`)
                                    } else {
                                        toReturn.in.push(`${key}=${_.compact(v.split(',')).join(',')}`)
                                    }
                                    break
                                case 'search_operator':
                                    computeOperator(key, v, toReturn)
                                    break
                                case 'search_date':
                                    computeDateOperator(key, v, toReturn, fieldConf.strictDate)
                                    break
                                case 'filter_only': toReturn.filterObj[key] = v
                                    break
                                default: console.log(`Unknown mode for ${key}:`, mode)
                            }
                        }
                    })
                }
            }
        })
        toReturn.sortObj = params.sorting()
        if (toReturn.sortObj && (Object.keys(toReturn.sortObj).length > 0)) {
            let sortKey = Object.keys(toReturn.sortObj)[0]
            if ((columns[sortKey] != null ? columns[sortKey].mode : undefined) !== 'filter_only') {
                if (toReturn.sortObj[sortKey] === 'desc') {
                    sortKey = `-${sortKey}`
                }
                toReturn.orderBy = sortKey
            }
        }

        // update adress bar
        if (!handler.preventAddressBar) {
            $location.search(_.assign(_.pick($location.search(), handler.preventQueryParamsOverride || []), searchObj))
        }

        return toReturn
    }

    const getData = function (searchAndOrder, transformer, apiCaller) {
        searchAndOrder.orderBy = searchAndOrder.orderBy ? searchAndOrder.orderBy : '-creation_ts'
        return apiCaller(searchAndOrder)
        .searchPaginated(searchAndOrder.search).$promise.then((data) => {
            if (transformer) {
                data.results = transformer(data.results) || data.results
            }
            return data
        })
    }

    const filterData = function (data, searchAndOrder) {
        let orderedData
        const deferred = $q.defer()
        const { filterObj } = searchAndOrder
        _.forEach(filterObj, (value, key) => {
            if ((value === undefined) || (value === null)) {
                return delete filterObj[key]
            }
        })
        const filteredData = $filter('filter')(data, filterObj)
        const { sortObj } = searchAndOrder
        if (sortObj && (Object.keys(sortObj).length > 0)) {
            const sortKey = Object.keys(sortObj)[0]
            orderedData = _.orderBy(filteredData, sortKey, sortObj[sortKey])
        } else {
            orderedData = filteredData
        }
        deferred.resolve(orderedData)
        return deferred.promise
    }

    const getTable = function (handler, resource, relations, transformer, override, apiCaller = DataAccessSearch) {
        let results
        let lastSearch
        const debounceList = {}
        const placeholders = {}
        const columnsConfig = {}
        const colBindings = {}
        const titleList = {}
        _.forEach(handler.columns, (col, colName) => {
            if (col) {
                columnsConfig[colName] = col.mode
                colBindings[colName] = col.binding
                placeholders[colName] = col.placeholder || placeholdersRef[col.mode]
                debounceList[colName] = col.debounce !== undefined ? col.debounce : DEFAULT_DEBOUNCE
                titleList[colName] = $sce.trustAsHtml(col.title || titleRef[col.mode])
            }
        })
        const caller = function (params) {
            const searchAndOrder = computeSearchAndOrder(params, handler, override)
            searchAndOrder.offset = (params.page() - 1) * params.count()
            searchAndOrder.limit = params.count()
            if (!_.isEqual(searchAndOrder, lastSearch)) {
                lastSearch = _.cloneDeep(searchAndOrder)
                // PERFORM SEARCH
                handler.refreshing = true
                searchAndOrder.search.resource = resource
                searchAndOrder.search.withRelated = relations
                return getData(searchAndOrder, transformer, apiCaller).then((data) => {
                    params.total(data.headers['x-results-count'])
                    return filterData(data.results, searchAndOrder).finally(() => {
                        MetaWatcher.notif(`TABLE_${resource.toUpperCase()}_DATA_CHANGED`)
                    })
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    handler.refreshing = false
                })
            }
            // FILTER
            return filterData(results, searchAndOrder)
        }

        const csv = function (filename, overrideResource) {
            const searchAndOrder = computeSearchAndOrder(handler.instance, handler, override, true)
            handler.refreshing = true
            searchAndOrder.offset = 0
            searchAndOrder.search.resource = overrideResource || resource
            return apiCaller(searchAndOrder)
            .searchPaginatedCsv(searchAndOrder.search).$promise.then((result) => {
                const url = URL.createObjectURL(result.response)
                const a = document.createElement('a')
                a.href = url
                a.download = filename || result.filename
                a.target = '_blank'
                document.body.appendChild(a)
                $timeout(() => {
                    a.click()
                })
            })
            .catch(ErrorCatcher)
            .finally(() => {
                handler.refreshing = false
            })
        }

        handler.instance = new NgTableParams({
            page: (handler.instance != null ? handler.instance.page() : undefined) || 1,
            count: (handler.instance != null ? handler.instance.count() : undefined) || 25,
            filter: (handler.instance != null ? handler.instance.filter() : undefined) || (handler.preventAddressBar ? {} : _.clone($location.search())),
            sorting: (handler.instance != null ? handler.instance.sorting() : undefined) || {},
        }, { counts: handler.counts || [10, 25, 50, 100], getData: caller })
        handler.instance.columns = columnsConfig
        handler.instance.bindings = colBindings
        handler.instance.placeholders = placeholders
        handler.instance.debounce = debounceList
        handler.instance.titles = titleList
        handler.instance.csv = csv
        handler.instance.labels = labels
    }



    return {
        getTable,
    }
})
